import React, { useState, useEffect } from 'react';
import {
  Row, Col, Spin, notification,
} from 'antd';
import {
  useNavigate, useLocation,
} from 'react-router-dom';
import ClassificacaoSoloDetails from '../details/Details';
import ClassificacaoSoloSummary from '../summary/Summary';
import SuccessSolicitation from '../../../serviceComponents/successSolicitation/SuccessSolicitation';
import { getUserType } from '../../../../../utils/users';

const ClassificacaoSoloFlow = () => {
  const initialParameters = () => ({
    isSkippingSteps: false,
    serviceList: [],

    selectedService: {
      id: 0,
      idCode: '',
      name: '',
      description: '',
      types: [],
    },

    selectedType: {
      id: 0,
      idCode: '',
      name: '',
      subtypes: [],
    },

    selectedProperty: {
      id: '',
      name: '',

      location: {
        lat: null,
        lon: null,
      },

      registeredOn: '',
      matriculation: '',
    },

    selectedMatriculation: getUserType() === 'COOPERCITRUS' ? null : 'COOPERATIVE',

    selectedOwner: {
      id: '',
      name: '',
    },

    serviceTypeDynamicFields: [],
    serviceSubtypeDynamicFields: [],
    talhoesSelecionados: [],
  });

  const [currentPage, setCurrentPage] = useState(-1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const locationObject = useLocation();
  const [serviceRequestParameters, setServiceRequestParameters] = useState(initialParameters());
  const [initialRequestParameters, setInitialRequestParameters] = useState(initialParameters());

  const removeSelectedField = (id) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        talhoesSelecionados: previous.talhoesSelecionados.filter((v) => v.id !== id),
      });
    });
  };

  useEffect(() => {
    setLoading(true);

    if (!locationObject.state?.serviceRequestParams) {
      notification.error({
        description: 'Houve um erro ao solicitar o serviço.',
      });

      setLoading(false);
      navigate('/service/new');

      return;
    }

    setServiceRequestParameters(locationObject.state?.serviceRequestParams);
    setInitialRequestParameters(locationObject.state?.serviceRequestParams);
    setCurrentPage(0);
    setLoading(false);
  }, []);

  const previousPage = (parameters) => {
    if (currentPage === 0) {
      navigate('/service/new', {
        state: {
          skipToPage: 3,
          serviceID: serviceRequestParameters.selectedService.id,
          matriculation: serviceRequestParameters.matriculation,
          allServiceParameters: serviceRequestParameters,
        },
      });
      return;
    }

    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous - 1);
  };

  const nextPage = (parameters) => {
    setServiceRequestParameters((previous) => {
      return ({
        ...previous,
        ...parameters,
      });
    });
    setCurrentPage((previous) => previous + 1);
  };

  return (
    <div className="ClassificacaoSoloFlow">
      <Spin tip="Carregando..." spinning={loading}>
        <Row>
          <Col span={24}>
            {
              getUserType() === 'COOPERCITRUS'
                ? (
                  <>
                    <div style={{ display: currentPage === 0 ? 'block' : 'none' }}>
                      {
                        currentPage === 0
                        && (
                          <ClassificacaoSoloDetails
                            previousPage={previousPage}
                            nextPage={nextPage}
                            serviceRequestParameters={serviceRequestParameters}
                            removeSelectedField={removeSelectedField}
                          />
                        )
                      }
                    </div>

                    <div style={{ display: currentPage === 1 ? 'block' : 'none' }}>
                      {
                        currentPage === 1
                        && (
                          <ClassificacaoSoloSummary
                            previousPage={previousPage}
                            nextPage={nextPage}
                            serviceRequestParameters={serviceRequestParameters}
                            removeSelectedField={removeSelectedField}
                          />
                        )
                      }
                    </div>

                    <div style={{ display: currentPage === 2 ? 'block' : 'none' }}>
                      <SuccessSolicitation
                        previousPage={previousPage}
                        params={serviceRequestParameters}
                      />
                    </div>
                  </>
                )
                : (
                  <>
                    {/* Classificacao de solo para cooperado ainda nao possui detalhes */}
                    {/* <div style={{ display: currentPage === 0 ? 'block' : 'none' }}>
                      {
                        currentPage === 0
                        && (
                          <ClassificacaoSoloDetails
                            previousPage={previousPage}
                            nextPage={nextPage}
                            serviceRequestParameters={serviceRequestParameters}
                            removeSelectedField={removeSelectedField}
                          />
                        )
                      }
                    </div> */}

                    <div style={{ display: currentPage === 0 ? 'block' : 'none' }}>
                      {
                        currentPage === 0
                        && (
                          <ClassificacaoSoloSummary
                            previousPage={previousPage}
                            nextPage={nextPage}
                            serviceRequestParameters={serviceRequestParameters}
                            removeSelectedField={removeSelectedField}
                          />
                        )
                      }
                    </div>

                    <div style={{ display: currentPage === 1 ? 'block' : 'none' }}>
                      <SuccessSolicitation
                        previousPage={previousPage}
                        params={serviceRequestParameters}
                      />
                    </div>
                  </>
                )
            }

          </Col>
        </Row>
      </Spin>
    </div>
  );
};

ClassificacaoSoloFlow.propTypes = {};
ClassificacaoSoloFlow.defaultProps = {};

export default ClassificacaoSoloFlow;
